import { writable, readable } from 'svelte/store';
export const app_version = writable({
    app_name: 'Collectif API Thinking',
    version: '1.5.0' // !! Penser à modifier la version dans index.html !!!
});
export const storeNumberEnterprise = writable(0);
export const storeNumberMember = writable(0);
export const storeNumberPartner = writable(0);
export const api_url_dev = readable('http://collectifapi.localhost/api/');
// HOSTINGER
// export const api_url_prod = readable('https://collectifapi.yvanpoirier.fr/back/api/');
// OVH
// export const api_url_prod = readable('http://knpnjql.cluster029.hosting.ovh.net/back/api/');
export const api_url_prod = readable('https://www.collectif-api-thinking.com/back/api/');
export const backend_url = writable('');
export const access_token = writable("");
export const storeLoader = writable(false);
export const storeTokenReinitPassword = writable("");
// Langue
export const storeLanguage = writable("fr");
export const lang_fr = readable("fr");
export const lang_en = readable("en");
